var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "standard-grid-wrapper" },
    [
      _c("standard-grid-layout", {
        attrs: {
          "grid-gap": _vm.gridGap,
          "grid-columns": _vm.gridColumns,
          items: _vm.gridItems,
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function ({ item, key }) {
              return [
                _c("split-content-card", {
                  key: key,
                  attrs: { content: item, aspect: _vm.aspectRatio },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }